export var border = {
  borderRadius: '4px'
};